module.exports = __webpack_public_path__ + "static/logo-3223d9ca6e541fd1c35f22f9d73c3474.png";